<main class="page" *ngIf="!submitted()">
  <mat-card class="card survey-card" appearance="outlined">
    <div class="top-bar">
      <img class="imt-logo imt-logo--hero" src="/imt_fi_logo_koralli.png" alt="" aria-hidden="true" />
      <div class="language-toggle" *ngIf="!loading() && !error()">
        <span class="language-toggle-label">{{ uiText('languageLabel') }}</span>
        <button
          mat-stroked-button
          type="button"
          class="language-toggle-button"
          [class.is-active]="selectedLocale() === 'fi'"
          [attr.aria-pressed]="selectedLocale() === 'fi'"
          (click)="setLocale('fi')"
        >
          FI
        </button>
        <button
          mat-stroked-button
          type="button"
          class="language-toggle-button"
          [class.is-active]="selectedLocale() === 'en'"
          [attr.aria-pressed]="selectedLocale() === 'en'"
          (click)="setLocale('en')"
        >
          EN
        </button>
      </div>
    </div>

    <app-survey-hero
      [eyebrow]="uiText('heroEyebrow')"
      [title]="uiText('heroTitle')"
      [subtitle]="getHeroSubtitle()"
    >
      <nav
        class="stepper"
        *ngIf="!loading() && !error() && pages().length > 1"
        aria-label="{{ uiText('sectionLabel') }}"
      >
        <ol class="stepper-list">
          <li
            class="stepper-step"
            *ngFor="let page of pages(); let i = index"
            [class.is-complete]="i < currentPageIndex()"
            [class.is-active]="i === currentPageIndex()"
            [attr.aria-current]="i === currentPageIndex() ? 'step' : null"
          >
            <span class="stepper-marker">{{ i + 1 }}</span>
            <span class="stepper-label">{{ getStepLabel(page.id) }}</span>
          </li>
        </ol>
      </nav>
    </app-survey-hero>

    <mat-progress-bar *ngIf="loading()" mode="indeterminate"></mat-progress-bar>
    <p class="status error" *ngIf="error()" role="alert">{{ error() }}</p>

    <form *ngIf="!loading() && !error()" [formGroup]="surveyForm" (ngSubmit)="submit()">
      <p class="status error" *ngIf="requiredFieldsError()" role="alert">{{ requiredFieldsError() }}</p>

      <section class="survey-page" *ngIf="currentPage() as page">
        <header class="survey-page-heading">
          <h2 *ngIf="text(page.title)">{{ text(page.title) }}</h2>
          <p
            class="survey-page-description"
            *ngIf="currentPageIndex() === 0 && text(page.description)"
          >
            {{ text(page.description) }}
          </p>
        </header>

        <section class="section" *ngFor="let section of page.sections">
          <div class="section-heading">
            <h3 class="section-title">{{ getSectionTitle(section) }}</h3>
            <p class="section-subtitle" *ngIf="getSectionSubtitle(section)">
              {{ getSectionSubtitle(section) }}
            </p>
          </div>
          <ul class="trip-phase-context" *ngIf="shouldShowContextList(section)">
            <ng-container *ngFor="let context of section.tripPhaseContext">
              <li *ngIf="shouldShowContextItem(section, context)">
                <ng-container *ngIf="context.start && context.end; else simpleContext">
                  {{ context.start }} -> {{ context.end }}
                </ng-container>
                <ng-template #simpleContext>
                  {{ context.name }}
                </ng-template>
              </li>
            </ng-container>
          </ul>

          <div
            class="question"
            *ngFor="let question of section.questions"
            [class.is-hidden]="!shouldShowQuestion(section, question)"
            [attr.aria-hidden]="!shouldShowQuestion(section, question)"
            [attr.inert]="!shouldShowQuestion(section, question) ? '' : null"
            [class.is-missing-required]="isMissingRequiredQuestion(section, question)"
          >
            <app-survey-question
              [question]="question"
              [fieldId]="buildFieldKey(section, question.id)"
              [control]="getQuestionControl(section, question.id)"
              [locale]="selectedLocale()"
              [requiredIndicator]="requiredIndicatorText(question)"
              [textareaPlaceholder]="uiText('textareaPlaceholder')"
            />
          </div>
        </section>
        <app-survey-public-review-preview
          *ngIf="page.id === 'tripReview'"
          [form]="surveyForm"
          [pages]="pages()"
          [locale]="selectedLocale()"
          [firstName]="firstName()"
        ></app-survey-public-review-preview>
      </section>

      <div class="nav-wrap">
        <p
          class="nav-error"
          [class.is-visible]="navigationErrorMessage().length > 0"
          aria-live="polite"
        >
          {{ navigationErrorMessage() }}
        </p>

        <p class="status error" *ngIf="submitFailureMessage()" role="alert">
          {{ submitFailureMessage() }}
        </p>

        <p
          class="privacy-notice"
          *ngIf="currentPageIndex() === pages().length - 1"
          [innerHTML]="uiText('privacyNotice')"
        ></p>

        <div class="nav">
          <button
            mat-stroked-button
            type="button"
            *ngIf="currentPageIndex() > 0"
            (click)="goBack()"
          >
            {{ uiText('backButton') }}
          </button>
          <span class="nav-spacer"></span>
          <button
            mat-flat-button
            color="primary"
            type="button"
            *ngIf="currentPageIndex() < pages().length - 1"
            (click)="goNext()"
          >
            {{ uiText('nextButton') }}
          </button>
          <button
            mat-flat-button
            color="primary"
            type="submit"
            *ngIf="currentPageIndex() === pages().length - 1"
            [disabled]="submitting()"
          >
            {{ uiText('submitButton') }}
          </button>
        </div>
      </div>
    </form>
  </mat-card>
</main>

<main class="page" *ngIf="submitted()">
  <mat-card class="card submitted-card" appearance="outlined">
    <h1>{{ uiText('thankYouTitle') }}</h1>
    <p [innerHTML]="uiText('thankYouBody')"></p>
  </mat-card>
</main>
